function SecondPage() {
    return (
        <div className='card'>
            <label className='label'>﴾ Sobre Mim ﴿</label>
            <div className='about-me'>
                <span>
                    Olá, me chamo Gelff. Atualmente estou cursando Jogos Digitais e pretendo seguir carreira na área de desenvolvimento de jogos.
                </span>
                <span>
                    Tenho planos de fazer intercâmbio para o Japão até 2028, com o intuito de alcançar a fluência no idioma japonês. Sou apaixonado pela cultura asiática, especialmente a cultura japonesa e desde criança o meu sonho é conhecer o Japão. Nos meus planos também inclui a continuidade dos meus estudos acadêmicos e obter o visto de residência permanente.
                </span>
                <span>
                    Alguns dos meus hobbies favoritos são: jogos, séries, filmes, animes e livros
                </span>
                <div className='about-me-footer'>
                    <span>Atualizado em</span>
                    <span>22/11/2025</span>
                    <span>às 01:42</span>
                </div>
            </div>
        </div>
    )
}

export default SecondPage